import { useAppSelector } from '../store/hooks'
import { hasAccessToSidebar } from '../utils'

export const useAccessSidebar = (permission: string | string[]) => {
  const permissions = useAppSelector(state => state.user.user?.sidebar_items)
  return hasAccessToSidebar(permissions || [], permission)
}
